import request from 'src/request/request';
import { log } from 'src/utils/notification';

export class WorkspaceService {
  async getAll() {
    try {
      const response = await request<any, any>( true, 'POST', 'services/workspaces/get-groups', {});
      // log('[WORKSAPCE] get all:', response, 'Info');
      return response?.workspaces.reverse();
    } catch (error: any) {
      log('services/workspaces/get-groups', { response: error.message }, 'Error');
    }
  }

  async getTabs(uuid: string) {
    try {
      const response = await request<any, any>( true, 'POST', 'services/workspaces/get-tabs', { uuid });
      // console.log('[TAB] get all:', { uuid, response });
      return response;
    } catch (error: any) {
      log('services/workspaces/get-group', { response: error.message }, 'Error');
    }
  }

  async setGroup(group: object) {
    try {
      const response = await request<any, any>( true, 'POST', 'services/workspaces/set-group', { group });
      // console.log('[Workspace] set:', { group, response });
      return response;
    } catch (error: any) {
      log('services/workspaces/set-group', { response: error.message }, 'Error');
    }
  }

  async update(workspace: object) {
    try {
      const response =  await request<any, any>( true, 'POST', 'services/workspaces/update-workspace', { workspace });
      // console.log('[Workspace] update:', { workspace, response });
      return response;
    } catch (error: any) {
      log('services/workspaces/update-workspace', { response: error.message }, 'Error');
    }
  }

  async delete(uuid: string) {
    try {
      const response =  await request<any, any>( true, 'POST', 'services/workspaces/delete-group', { uuid });
      // console.log('[Workspace] delete:', { uuid, response });
      return response;
    } catch (error: any) {
      log('services/workspaces/delete-group', { response: error.message }, 'Error');
    }
  }
}
